module.exports = __webpack_public_path__ + "static/media/PaymentOfferScreen.fe4d90aa.png";